import { autoBetStore } from '../../../store/autoBetStore';
import { alternativeDiceBetsStore } from '../alternativeDiceStore/betStore';
import { userInfoStore } from '../../../store/userInfoStore';
import {
  ALTERNATIVE_DICE_ANIMATION_DURATION,
  ALTERNATIVE_DICE_RANGE_FROM,
  ALTERNATIVE_DICE_RANGE_TO,
} from '../alternativeDiceCore/constants';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { ValidationType } from '../../../core/constants/validationType';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { notificationStore } from '../../../store/notificationStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { AlternativeDiceSoundsName } from '../alternativeDiceCore/sounds';

import { isPG } from '../../../core/helpers/skinHelper';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';
import { freeBetStore } from '../../../store/freeBetStore';

let resetTimeOutId;

class AlternativeDiceGameService {
  onGetInitialStateResult({ lastSpinInfo }) {
    this.handleResetInitial();
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo(lastSpinInfo);
      checkHashStore.setLastRoundResult({
        resultNumber: lastSpinInfo.resultNumber,
        id: lastSpinInfo.id,
      });
    }

    if (isPG()) {
      userInfoStore.setMargin(3);
    } else {
      userInfoStore.setMargin(1);
    }
  }

  doSpin() {
    if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
      autoBetStore.setIsAutoBetStart(true);
    }
    if (alternativeDiceBetsStore.isBetsClosed) {
      return;
    }

    soundService.play(AlternativeDiceSoundsName.bet);
    const model = {
      spinData: {
        spinMarket: alternativeDiceBetsStore.rangeType,
        from: alternativeDiceBetsStore.rangeValue[ALTERNATIVE_DICE_RANGE_FROM],
        to: alternativeDiceBetsStore.rangeValue[ALTERNATIVE_DICE_RANGE_TO],
        amount: userInfoStore.betAmount,
      },
      isAutoplay: autoBetStore.isAutoBetOn,
    };
    alternativeDiceBetsStore.setIsBetsClosed(true);
    mainGameConnection.doSpin(model);
  }

  handleDoSpinResult({
    responseCode,
    winAmount,
    odd,
    salt,
    key,
    hash,
    id,
    newHash,
    result,
    balance,
  }) {
    if (responseCode === ValidationType.Success) {
      const { resultNumber } = result;
      if (!freeBetStore.currentFreeBet) {
        userInfoStore.setUserBalance(balance);
      }
      alternativeDiceBetsStore.setIsStartAnimation(true);
      alternativeDiceBetsStore.setIsWin(false);
      alternativeDiceBetsStore.setGameResult(null);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
      }
      checkHashStore.setLastRoundInfo({ salt, key, hash });
      checkHashStore.setNextRoundHash(newHash);
      checkHashStore.setLastRoundResult({ resultNumber, id });

      if (userSettingsStore.isTurboOn) {
        soundService.play(AlternativeDiceSoundsName.turbo);
        alternativeDiceBetsStore.updateLastResults({ resultNumber, isWin: Boolean(winAmount) });
        setTimeout(() => {
          winAmount && soundService.play(AlternativeDiceSoundsName.win);
          alternativeDiceBetsStore.setWinAmount(winAmount);
          alternativeDiceBetsStore.setWinOdd(odd);
        }, 200);
        setTimeout(() => {
          this.resetGameStoreData();
        }, 500);
      } else {
        soundService.play(AlternativeDiceSoundsName.reels);
        setTimeout(() => {
          alternativeDiceBetsStore.updateLastResults({ resultNumber, isWin: Boolean(winAmount) });
          setTimeout(() => {
            alternativeDiceBetsStore.setWinAmount(winAmount);
            alternativeDiceBetsStore.setWinOdd(odd);
            winAmount && soundService.play(AlternativeDiceSoundsName.win);
          }, 400);
          setTimeout(() => {
            this.resetGameStoreData();
          }, 1800);
          soundService.stop(AlternativeDiceSoundsName.reels);
        }, ALTERNATIVE_DICE_ANIMATION_DURATION);
      }
    } else {
      notificationStore.setNotification(responseCode);
      alternativeDiceBetsStore.setIsBetsClosed(false);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
    }
  }

  resetAutoBetState() {
    if (autoBetStore.isAutoBetStart && autoBetStore.isAutoBetOn && !autoBetStore.autoBetCount) {
      setTimeout(() => {
        autoBetStore.resetAutoBetState();
        this.clearAutoBetTimeOut();
      }, 1500);
    }
  }

  clearAutoBetTimeOut() {
    clearTimeout(resetTimeOutId);
  }

  resetGameStoreData() {
    alternativeDiceBetsStore.setIsStartAnimation(false);
    alternativeDiceBetsStore.setIsBetsClosed(false);
    alternativeDiceBetsStore.setWinAmount(null);
    alternativeDiceBetsStore.setWinOdd(null);
    betHistoryStore.getLastBet();
    userInfoStore.getBalance();
    this.repeatAutoBet();
  }

  repeatAutoBet() {
    resetTimeOutId = setTimeout(() => {
      if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
        this.doSpin();
      } else {
        this.resetAutoBetState();
      }
    }, 1000);
  }

  handleResetInitial() {
    this.resetAutoBetState();
    alternativeDiceBetsStore.setIsStartAnimation(false);
    alternativeDiceBetsStore.setIsBetsClosed(false);
    alternativeDiceBetsStore.setWinAmount(null);
    alternativeDiceBetsStore.setWinOdd(null);
  }
}

export const alternativeDiceGameService = new AlternativeDiceGameService();
